import Vue from 'vue'
import { mapActions } from 'vuex'
import { router } from '@src/routes'

import UIAdsBanner from './components/ads-banner/ads-banner.vue'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import UIViewButtons from './components/view-buttons/view-buttons.vue'
import UIFilter from '@components/ui-components/filter-container/filter-container.vue'
import UIEventsList from './components/events-list/events-list.vue'
import UIEventsCalendar from './components/events-calendar/events-calendar.vue'
import UIPopover from './components/popover/popover.vue'

import { EVENT_VIEWS, DEFAULT_EVENT_VIEW } from '@modules/events/domain/data/view'
import { getCookieValue } from '@shared/utils/cookie'
import { loadTemplate } from '@shared/utils/template'
import { buildEventQuery } from '@modules/events/domain/utils/query'
import { isEmptyObject } from '@modules/shared/utils/object'
import { getDefaultDate } from '@modules/events/domain/utils/date'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      events: [],
      focus: '',
      eventClick: [],
      modalForm: null,
      adsBanner: null,
      currentView: null,
    }
  },
  components: {
    'ui-ads-banner': UIAdsBanner,
    'page-form-cmp': PageForm,
    'ui-view-buttons': UIViewButtons,
    'ui-filter': UIFilter,
    'ui-events-list': UIEventsList,
    'ui-events-calendar': UIEventsCalendar,
    'ui-popover': UIPopover,
  },
  computed: {
    isListView() {
      return this.currentView === EVENT_VIEWS.LIST
    },
  },
  methods: {
    ...mapActions('modal', ['modalClose']),
    ...mapActions('events', {
      getCalendarEvents: 'getCalendarEvents',
      getListEvents: 'getListEvents',
      events_setPopoverClosed: 'setPopoverClosed',
    }),
    setView(view) {
      if (!view || this.currentView === view) return

      const query = {
        ...this.$route.query,
        view,
      }

      if (view === EVENT_VIEWS.LIST) {
        query.startDate = getDefaultDate()
        query.endDate = undefined
      }

      this.currentView = view

      this.$router.push({ query })
    },
    async getEvents(query) {
      switch (query.view) {
        case EVENT_VIEWS.CALENDAR:
          await this.getCalendarEvents(query)
          break
        case EVENT_VIEWS.LIST:
          await this.getListEvents(query)
          break
        default:
          break
      }
    },
    buildQuery(rawQuery) {
      const region = getCookieValue('regionSlug')

      const query = buildEventQuery(rawQuery, region)

      if (!query.region) {
        console.error('Не удалось считать region')
      }

      return query
    },
  },
  async beforeRouteUpdate(to, _, next) {
    if (!isEmptyObject(to.query)) {
      await this.getEvents(this.buildQuery(to.query))
    }

    next()
  },
  async created() {
    this.events_setPopoverClosed()
    // выставляем дефолтный вид (список / плитка)
    const query = this.buildQuery(this.$route.query)

    this.currentView = query.view ?? DEFAULT_EVENT_VIEW

    if (this.currentView === EVENT_VIEWS.CALENDAR && !query.startDate) {
      return
    }

    await this.getEvents(query)
  },
  async beforeRouteEnter(to, _, next) {
    if (window.content) {
      next(vm => {
        vm.template = window.content
        window.content = undefined
      })
      return
    }

    const path = to.path.replace(router.history.base, '')

    try {
      const data = await loadTemplate(path)

      next(vm => (vm.template = data))
    } catch ({ status }) {
      if (status === 403) {
        next({ name: 'E403' })
      }

      next({ name: 'E404' })
    }
  },
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/events/index.js